import { SCORE_TIERS } from './gameConstants';

/** Narasi penutup — konsep game SEISM */
export const ENDING_NARRATION =
  'Bujang bertemu Ibundo Putri Rimas di titik kumpul aman.';

/** Kalimat Rafflesia Final — konsep game SEISM */
export const RAFFLESIA_FINAL_QUOTE =
  'Selamat. Dengan mengikuti petunjuk Keris Pusaka dan semangat Sekundang Setungguan, kamu berhasil menyelamatkan Ibundo dan warga desa!';

export interface EndingCelebrationCopy {
  headline: string;
  subtitle: string;
  storyLine: string;
  rafflesiaFinal: string;
  speech: string;
  tierFlavor: string;
}

function headlineForPoints(points: number): string {
  if (points >= SCORE_TIERS.HERO.min) return 'SELAMAT, PAHLAWAN SEKUNDANG SETUNGGUAN!';
  if (points >= SCORE_TIERS.VOLUNTEER.min) return 'SELAMAT, RELAWAN SIAGA!';
  return 'SELAMAT, WARGA BIASA!';
}

/** Teks penutup ending — sederhana, mengikuti konsep (narasi + Rafflesia Final + gelar skor). */
export function getEndingCelebration(
  playerName: string,
  _tier: string,
  points: number,
): EndingCelebrationCopy {
  const name = playerName.trim() || 'Bujang Awang Tabuang';

  return {
    headline: headlineForPoints(points),
    subtitle: name,
    storyLine: ENDING_NARRATION,
    rafflesiaFinal: RAFFLESIA_FINAL_QUOTE,
    speech: RAFFLESIA_FINAL_QUOTE,
    tierFlavor: '',
  };
}
